import { hash } from '@ember/helper';
import CustomRow from './custom-row.gts';
import CustomRowReview from './custom-row-review.gts';
import LoadingRow from './loading-row.gts';
import { t } from 'ember-intl';
import TioClickableText from '../../tio/clickable-text.gts';
import type { ComponentLike } from '@glint/template';
import type { TOC } from '@ember/component/template-only';
import type { TasProgramTemplateReviewCustomRowSig } from './custom-row.ts';
import type { TuitionAssistanceProgramTemplateReviewCustomRowReviewSignature } from './custom-row-review.ts';
import { PhPlus } from 'ember-phosphor-icons';
import { Section } from 'tio-ui/components/layout';

interface TasPrgmTmplReviewAddCustomFieldSig {
  Args: {
    addCustomRow?: () => void;
    showCustomField: boolean;
    isLoadingNewRow?: boolean;
  };
  Blocks: {
    default: [
      {
        row: ComponentLike<TasProgramTemplateReviewCustomRowSig>;
        customRowReview: ComponentLike<TuitionAssistanceProgramTemplateReviewCustomRowReviewSignature>;
        loadingRow: ComponentLike<unknown>;
      },
    ];
  };
}

const TasProgramTemplateReviewAddCustomField: TOC<TasPrgmTmplReviewAddCustomFieldSig> = <template>
  <Section>
    {{#if @showCustomField}}
      <h2 class="font-semibold col-span-3 text-sm mt-6 mb-4 uppercase">
        {{t "common.tuition_assistance.program_template_review.custom_field.custom_fields_added"}}
      </h2>
      <div
        class="grid grid-cols-10 gap-8 font-semibold bg-ocean-50 p-4 justify-center items-center"
      >
        <h3 class="col-span-1">
          {{t "common.tuition_assistance.program_template_review.custom_field.order_number"}}
        </h3>
        <h3 class="col-span-3">{{t "common.tuition_assistance.program_template_review.field"}}</h3>
        <h3 class="col-span-2 pl-4">
          {{t "common.tuition_assistance.program_template_review.type"}}
        </h3>
        <h3 class="col-span-2 justify-self-center">
          {{t "common.tuition_assistance.program_template_review.visible_to_employees"}}
          /{{t "common.required"}}
        </h3>
      </div>
      {{yield
        (hash
          row=(component CustomRow)
          customRowReview=(component CustomRowReview)
          loadingRow=(component LoadingRow)
        )
      }}
    {{/if}}

    {{#if @addCustomRow}}
      <TioClickableText
        @onClick={{@addCustomRow}}
        @icon={{PhPlus}}
        @iconLeft={{true}}
        @outlined={{true}}
        @textClass="text-sm font-semibold uppercase"
        class="m-2"
      >
        {{t "common.tuition_assistance.program_template_review.add_custom_field"}}
      </TioClickableText>
    {{/if}}
  </Section>
</template>;

export default TasProgramTemplateReviewAddCustomField;
